import React from 'react';
import PropTypes from 'prop-types';

import { connectToStore } from '../../reflux/decorators/connect_to_store';
import mixin from 'react-mixin';
import { FlashMessagesStore, FlashMessagesActions } from '../reflux/flash_messages_store';
import RealizeFlash from 'realize/components/flash/flash';

// @connectToStore(FlashMessagesStore)
@mixin.decorate(Realize.ContainerMixin)
@mixin.decorate(Reflux.listenTo(FlashMessagesStore, "onFlahMessageStoreLoad"))
export default class FlashMessages extends React.Component {
	static propTypes = {
		id: PropTypes.string
	};

	static defaultProps = {
		id: ""
	};

	componentDidMount() {
		FlashMessagesActions.init({
			id: this.props.id,
			messages: []
		});
	}


	onFlahMessageStoreLoad(store, callback) {
		if (store && store.id === this.props.id) {
			if (callback) {
				this.setState(store, callback);
			} else {
				this.setState(store);
			}
		}
	}

	focusInFlashMessage(){
		setTimeout(() => {
			let messagesWrapperError = $('.messages-wrapper .flash--error');
			let messagesWrapperSuccess = $('.messages-wrapper .flash--success');
			let modalAssignActivityVisible = $('#assign-activity-to-user-modal').is(':visible');

			if(modalAssignActivityVisible === false){
				if(messagesWrapperError.length > 0){
					let iconMessage = $('.messages-wrapper .flash--error .flash__dismiss');
					let iconVisible = iconMessage.is(':visible');

					if(iconVisible === true){
						let msgError = $('.messages-wrapper .flash--error p');

						msgError.attr('tabindex', '0').focus();
						iconMessage.attr('tabindex', '0').attr('aria-label', Realize.i18n.t('general.error.close'));
						iconMessage.unbind('keydown').keydown((e) => {
							e.which === 13 && e.currentTarget.click();
						})
					}
				}
				else if(messagesWrapperSuccess.length > 0){
					let iconMessage = $('.messages-wrapper .flash__dismiss');
					let iconVisible = iconMessage.is(':visible');

					if(iconVisible === true){
						let msgSuccess = $('.messages-wrapper .flash--success p');
						let msgError = $('.flash--error div div')

						let isModal = false;
						const listModal = document.querySelectorAll('.realize-modal');
						Array.prototype.forEach.call(listModal, function(modal){
							if(modal.style.display === "block"){
								isModal = true
							}
						});

        				if(!isModal){
							msgSuccess.attr('tabindex', '0').focus();
						}

						iconMessage.attr('tabindex', '0').attr('aria-label', Realize.i18n.t('general.success.close'));
						iconMessage.unbind('keydown').keydown((e) => {
							e.which === 13 && e.currentTarget.click();
						})

						iconMessage.unbind('click').click(() => {
							if(msgError.length > 0){
								setTimeout(() => {
									msgError.focus();
								}, 0)
							}
						})
					}
				}
			}
		}, 500)
	}

	renderMessages() {
		const that = this;
		return !this.state ? null : this.state.messages.map((message) => {
			return <RealizeFlash
				{...message}
				onDismiss={function() { that.handleFlashDismiss.call(that, this.id) }}
				key={message.id} />;
		});
	}

	handleFlashDismiss(messageId) {
		FlashMessagesActions.removeMessage(this.props.id, messageId);
	}

	render() {
		return (
			<div className="messages-wrapper">
				{this.renderMessages()}
			</div>
		);
	}
}
